import { setCategories, setLoading, setError, setPagination } from "../slices/category";
import axios from "axios";

export const getCategories = (page, favouriteToggle) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get("/api/categories");
    const { categories, pagination } = data;
    dispatch(setCategories(categories));
    dispatch(setPagination(pagination));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occured reading categories. Please try again later"
      )
    );
  }
};
